import React from "react";
import {useHistory} from "react-router";
import MButton from "@/components/atom/MButton";

const About = () => {
  const history = useHistory()

  return (
    <div className="App" style={{ padding: '40px' }}>
      <h1>名刺Rについて</h1>

      <p>
        あなたの名刺をスマホで撮影して保存「名刺R」に登録するだけでWEBツールになります。簡易販促ツールとしてのHPを作成、名刺のQRを作成して離れた方とQRによる名刺交換が可能となります。<br/>
        名刺を渡した人に、年間の営業日をお伝えできます。業務内容のメニュー、その他情報をテキスト、画像でスマホに反映、その進捗内容をすでにお渡しした全員に確認していただけます。
      </p>

      <p>
        名刺の登録料は１件550円(税込)で名刺のQRが作成されます。ご自身の名刺を登録しない、名刺を持たない名刺をいただくだけの方は無料で「名刺R」をご利用できます。<br/>
        ●初回割安料金<br/>
        あなたの名刺をお渡しする方が50人までは名刺の登録料以外は初回割安料金適用で無料です。51人から毎月550円(税込)、501名から毎月770円(税込)の課金となります。<br/>
      </p>

      <p>
        今まで個人事業主で販促ツールに困っておられた方は「名刺R」をご利用ください。あなたの名刺を「名刺R」に登録すればQRが作成されます、そのQRを配布すればあなたの名刺の内容から年間の営業日、業務内容のメニュー、その他情報がWEBツールとして渡した方に閲覧していただけますので営業展開する時のコミュニケーションツールになると思われます。
      </p>

      <MButton image={'back.png'} onClick={() => history.goBack()} value={'戻る'} />
    </div>
  )
}

export default About;
